import React from 'react';
import {
	Table,
	TableHead,
	TableHeadRow,
	TableHeadCell,
	TableBody,
	TableRow,
	TableCell,
} from './table';
import { topscorers_statistieken } from '../lib/historicalData';

export default function TopscorersTable() {
	return (
		<div className="overflow-x-auto">
			<Table className="table-auto overflow-scroll w-full">
				<TableHead>
					<TableHeadRow>
						<TableHeadCell>Seizoen</TableHeadCell>
						<TableHeadCell>Speler</TableHeadCell>
						<TableHeadCell>Club</TableHeadCell>
						<TableHeadCell>Doelpunten</TableHeadCell>
					</TableHeadRow>
				</TableHead>
				<TableBody className="bg-white divide-y divide-gray-200">
					{topscorers_statistieken.map((seizoen, i) => (
						<TableRow key={i} striped>
							<TableCell>{seizoen.Seizoen}</TableCell>
							<TableCell>{seizoen.Speler}</TableCell>
							<TableCell>{seizoen.Club}</TableCell>
							<TableCell>{seizoen.Doelpunten}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
